import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-colors duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#FDF8F0]';
  const variants = {
    primary: 'bg-[#2D3B2D] text-[#FDF8F0] hover:bg-[#1a241a] focus:ring-[#2D3B2D]',
    secondary: 'bg-[#C4A962] text-[#2D3B2D] hover:bg-[#b09555] focus:ring-[#C4A962]',
    outline: 'border-2 border-[#2D3B2D] text-[#2D3B2D] hover:bg-[#2D3B2D] hover:text-[#FDF8F0] focus:ring-[#2D3B2D]'
  };
  const sharedProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    className: `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={props.onClick as any} {...sharedProps} data-id="element-316">
        {children}
        {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-317" />}
      </motion.a>;
  }
  return <motion.button {...sharedProps} {...props} data-id="element-318">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-319" />}
    </motion.button>;
}